import styles from './PhoneMockup.module.css';
import appHome from '../../assets/images/app-home.jpeg';

interface PhoneMockupProps {
  className?: string;
  scale?: number;
  transformOrigin?: string;
  /** `cover` fills the screen (may crop). `contain` shows the full image. */
  imageFit?: 'cover' | 'contain';
  /**
   * `fluid` — size to a container-query parent (no transform scale); avoids
   * overflow clipping that made the screenshot look zoomed. Use inside a
   * `container-type: size` wrapper (e.g. features rail).
   */
  mode?: 'default' | 'fluid';
}

export function PhoneMockup({
  className = '',
  scale = 1,
  transformOrigin = 'top center',
  imageFit = 'cover',
  mode = 'default',
}: PhoneMockupProps) {
  const isFluid = mode === 'fluid';

  if (isFluid) {
    return (
      <div className={`${styles.phoneFluid} ${className}`}>
        <div className={`${styles.screen} ${styles.screenFluid}`}>
          <img src={appHome} alt="LuvLust app home screen" />
        </div>
        <div className={styles.notchFluid} />
      </div>
    );
  }

  return (
    <div
      className={`${styles.phone} ${className}`}
      style={scale !== 1 ? { transform: `scale(${scale})`, transformOrigin } : undefined}
    >
      <div className={styles.screen}>
        <img
          src={appHome}
          alt="LuvLust app home screen"
          className={imageFit === 'contain' ? styles.imgContain : undefined}
        />
      </div>
      <div className={styles.notch} />
    </div>
  );
}
